<template>
  <div class="d-flex justify-content-between m-1 pe-0 fw-bold">
    <div class="ms-3">{{ user?.firstName }} {{ user?.lastName }}</div>
    <div>{{ user?.postTitle }}</div>
  </div>
</template>

<script>
export default {
  props: ['user']
}
</script>